export const getExportLinkSelector = state => state.exportLink;
export const getFilterFromBrandUploadSelector = state => state.backoffice.filterSelected;
